export class SatellitePage {
    protected $el: JQuery;
    private index: number;

    private name: string;
    private title: string;

    private started = false;

    public constructor (index: number, $el: JQuery) {
        this.$el = $el;
        this.index = index;

        this.init();
    }

    private init(): void {
        this.name = this.$el.data('name');
        this.title = this.$el.data('title');
    }

    public getEl(): JQuery {
        return this.$el;
    }

    public getIndex(): number {
        return this.index;
    }

    public getName(): string {
        return this.name;
    }

    public getTitle(): string {
        return this.title;
    }

    public onInit(): void {

    }

    public onStart(): void {

    }

    public onFocus(): void {
        if (!this.started) {
            this.started = true;

            this.onStart();
        }
    }

    public onBlur(): void {

    }
}
